//FAQ
export * from './faq/faq-list/faq-row/faq-row.component';
export * from './faq/faq-list/faq-list.component';
export * from './faq/faq';

//Pay-NCC
export * from './pay/pay-payment-instruction/pay-payment-instruction.component';
export * from './pay/pay-service/pay-service.component';
export * from './pay/pay-Ncc/pay-Ncc.component';
export * from './pay/pay';
export * from './pay/upload-proof-of-payment/upload-proof-of-payment.component';
//Dashboard
export * from './dashboard/dashboard.component';

//Sign-in
export * from './sign-in/sign-in.component';
export * from './foreign-details/foreign-details.component';
export * from './user-account/user-account.component';
export * from './forgot-password/forgot-password.component';

//Contact
export * from './contact/contact.component';
export * from './chat/chat.component';
export * from './chat/chat-messages/chat-messages.component';

//Account
export * from './sign-up/step3/step3.component';
export * from './sign-up/step2/step2.component';
export * from './sign-up/step1/account-row/account-row.component';
export * from './sign-up/step1/step1.component';
export * from './sign-up/signup';
export * from './sign-up/account-info/account-info.component';
export * from './sign-up/step4/step4.component';
export * from './sign-up/identification/identification.component';
export * from './sign-up/login/login.component';
export * from './invitation/invitation.component';
export * from './sign-up/irr-step2/step2.component';

//notification
export * from './notification/notification.component';
export * from './privacy/privacy.component';

export * from './reset-password/reset-password.component';
export * from './email-verification/email-verification.component';

export * from './payment-instruction/payment-instruction.component';

// PROCURMENT TENDERS
export * from './customer-tender/customer-tender.component';
export * from './customer-tender/customer-tender-list/customer-tender-list.component';
